import React, { useMemo } from 'react';
import { IonActionSheet } from '@ionic/react';

export default function MiOverflowMenu({
  isOpen,
  onClose,
  onSelectCapability,
  onSignOut,
  hasAdminPanelAccess = false,
  isPartnerUser = false
}) {
  const buttons = useMemo(() => {
    const base = [
      {
        text: 'Perfil e conta',
        handler: () => onSelectCapability?.('profile_settings')
      },
      {
        text: 'Plano e assinatura',
        handler: () => onSelectCapability?.('profile_plan')
      },
      {
        text: 'Suporte',
        handler: () => onSelectCapability?.('support_community')
      },
      {
        text: 'Configurações',
        handler: () => onSelectCapability?.('profile_settings')
      }
    ];

    if (hasAdminPanelAccess) {
      base.push({
        text: 'Painel admin',
        handler: () => onSelectCapability?.('admin_panel')
      });
    }

    if (isPartnerUser) {
      base.push({
        text: 'Painel parceiro',
        handler: () => onSelectCapability?.('partner_panel')
      });
    }

    base.push(
      {
        text: 'Sair',
        role: 'destructive',
        handler: () => onSignOut?.()
      },
      {
        text: 'Cancelar',
        role: 'cancel'
      }
    );

    return base;
  }, [hasAdminPanelAccess, isPartnerUser, onSelectCapability, onSignOut]);

  return (
    <IonActionSheet
      isOpen={isOpen}
      onDidDismiss={onClose}
      header="Game Pro Hub"
      subHeader="Conta, plano e suporte"
      buttons={buttons}
      cssClass="mi-overflow-sheet"
    />
  );
}
